import * as date from '../common/date';
import {all, maxBy} from '../common/seq';
export type OrderProductVariant = {
    id: number;
    productId: number;
    productName: string;
    attributeInfo: string;
    attributesAsQuery: string;
    quantity: number;
    subTotal: string;
    unitPrice: string;
    fabricProductId?: number;
    itemImageUrl?: string;
};

export type Order = {
    id: number;
    createdOn: string;
    orderTotal: string;
    orderStatus: string;
    needsCustomization: boolean;
    estimatedDelivery: string;
    shippedOn: string;
    deliveredOn: string;
    pendingReviewUrl: string;
};

export type Address = {
    firstName: string;
    lastName: string;
    email: string;
    address1: string;
    address2?: string;
    city: string;
    countryId: number;
    countryName: string;
    stateProvinceId: number;
    stateProvinceName: string;
    zipPostalCode: string;
};

export type Shipment = {
    deliveryDate?: string;
    shippedDate: string;
    trackingNumber: string;
    shippingMethod: string;
};

export type Timestamped = { createdOn: string };
export type OrderNote = Timestamped & { note: string };

export type OrderDetail = Order & {
    items: OrderProductVariant[];
    orderSubtotal: string;
    orderSubTotalDiscount: string;
    orderTotalDiscount: string;
    redeemedRewardPointsAmount: string;
    billingAddress: Address;
    shippingAddress: Address;
    shippingMethod: string;
    shippingStatus: string;
    shipments: Shipment[];
    tax: string;
    orderNotes: OrderNote[];
};

export enum OrderStatus {
    Pending,
    Received,
    Processing,
    ContactSupplier,
    Customizing,
    Shipped,
    Delivered,
    Complete,
    PendingReview,
    ReviewSubmitted,
    Reviewed,
    Cancelled,
    ReturnRequested,
    ReturnLabelSent,
    ReturnReceived,
    Refunded
}

export const isShipped = (order: Order) => !!order.shippedOn;
export const isDelivered = (order: Order) => !!order.deliveredOn;
export const shippedOn = (order: OrderDetail) => date.displayUtcDate(order.shippedOn);
export const needsCustomization = (order: Order) => order.needsCustomization;
export const estimatedDaysToDelivery = (order: Order) => needsCustomization(order) ? 35 : 7;
export const canTrackShipment = (order: Order) => isShipped(order) && date.utcDateFrom(order.shippedOn) > date.daysAgo(80);
export const pendingReview = (order: OrderDetail) => !!order.pendingReviewUrl;

export const estimatedDelivery = (order: Order) => {
    if (isShipped(order)) {
        if (isDelivered(order)) {
            return order.deliveredOn;
        }

        return date.displayUtcDate(date.inDays(date.utcDateFrom(order.shippedOn))(8).toISOString());
    }

    return date.displayUtcDate(date.inDays(date.utcDateFrom(order.createdOn))(estimatedDaysToDelivery(order)).toISOString());
};
